// extracted by extract-css-chunks-webpack-plugin
module.exports = {"access_request":"ActivityObject__access_request--1e0Kl","followable_user":"ActivityObject__followable_user--1f6YF"};